import React from 'react'

import {
  Text,
  Color,
  FontWeight,
  Box,
  Display,
  FlexDirection,
  JustifyContent,
  AlignItems,
  Space,
} from '@gousto-internal/citrus-react'

type TextBlockProps = { title: string; text: string }

export const TextBlock = ({ title, text }: TextBlockProps) => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    justifyContent={JustifyContent.Center}
    alignItems={AlignItems.FlexStart}
  >
    <Text fontWeight={FontWeight.Bold} color={Color.ColdGrey_800} size={[3, 5]}>
      {title}
    </Text>
    <Space dir="vertical" size={[1, 2]} />
    <Text color={Color.ColdGrey_800} size={[2, 3]}>
      {text}
    </Text>
  </Box>
)
